import React from 'react';
import { Badge } from 'react-bootstrap';
import { format } from 'date-fns';
import { DokumentInfo } from 'services/KjederegisteretAdminApi/DocsApi/types';

const formatDato = (dato?: Date | string | null) =>
  dato ? format(new Date(dato), 'dd.MM.yyyy') : '';

/** Viser om reglene i dokumentet er bekreftet av produkteier, med lenke til saken der det bekreftes. */
const DokumentStatus = ({ info }: { info: DokumentInfo }) => {
  const bekreftet = info.status === 'bekreftet';
  return (
    <span>
      <Badge bg={bekreftet ? 'success' : 'warning'} text={bekreftet ? undefined : 'dark'}>
        {bekreftet
          ? `Bekreftet${info.bekreftetAv ? ` av ${info.bekreftetAv}` : ''}`
          : 'Venter på bekreftelse fra produkteier'}
      </Badge>
      {info.ab && (
        <a
          className="ms-2"
          href={`https://tradesolution.visualstudio.com/_workitems/edit/${encodeURIComponent(info.ab)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          AB#{info.ab}
        </a>
      )}
      {info.sistOppdatert && (
        <span className="ms-2 text-muted">Sist oppdatert {formatDato(info.sistOppdatert)}</span>
      )}
    </span>
  );
};

export default DokumentStatus;
